import * as Types from '../constants/Types';
import Rating from './../models/Rating';
import { PAGINATION } from '../constants/Define';
import { findIndex } from 'lodash';

const initialState = {
    isFetching: false,
    approvingId: undefined,
    deletingId: undefined,
    ratings: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    totalPage: 0,
    orderBy: undefined,
    orderByDesc: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.RATING_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.RATING_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                ratings: action.ratings,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
                orderBy: action.orderBy,
                orderByDesc: action.orderByDesc,
            };
        case Types.RATING_APPROVE_ACTION:
            return { ...state, approvingId: action.rating.id };
        case Types.RATING_APPROVE_SUCCESS:
            const approveRatingIndex = findIndex(state.ratings, item => item.id === action.rating.id)
            if (approveRatingIndex >= 0) state.ratings[approveRatingIndex].isApproved = !action.rating.isApproved;
            return {
                ...state,
                approvingId: undefined,
                ratings: state.ratings,
            };
        case Types.RATING_DELETE_ACTION:
            return { ...state, deletingId: action.rating.id };
        case Types.RATING_DELETE_SUCCESS:
            return { ...state, deletingId: undefined };
        case Types.RATING_REPLY_APPROVE_ACTION:
            return { ...state, approvingId: action.reply.id };
        case Types.RATING_REPLY_APPROVE_SUCCESS:
            const approveReplyRatingIndex = findIndex(state.ratings, item => item.id === action.reply.ratingId)
            if (approveReplyRatingIndex >= 0) {
                const index = findIndex(state.ratings[approveReplyRatingIndex].replies || [], item => item.id === action.reply.id);
                if(index >= 0) state.ratings[approveReplyRatingIndex].replies[index].isApproved = !action.reply.isApproved;
            };
            return {
                ...state,
                approvingId: undefined,
                ratings: state.ratings,
            };
        case Types.RATING_FAIL:
            return { ...state, isFetching: false, approvingId: undefined, deletingId: undefined };
        default:
            return state;
    }
}
